import Validator from 'is_js'
import { isEmpty } from "lodash";

export function addAdmin(data) {
  let errors = {};
  const emailRegex = /^.+@.+\..+$/

  if (Validator.empty(data.firstName)) {
    errors.firstName = "First Name is required";
  } else if (data.firstName.length > 60) {
    errors.firstName = "First Name must be less than 60 characters";
  }

  if (Validator.empty(data.lastName)) {
    errors.lastName = "Last Name is required";
  } else if (data.lastName.length > 60) {
    errors.lastName = "Last Name must be less than 60 characters";
  }

  if (Validator.empty(data.email)) {
    errors.email = "Email is required";
  }

  if (!Validator.empty(data.email) && !emailRegex.test(data.email)) {
    errors.email = "Invalid email address"
  }

  return {
    isValid: isEmpty(errors),
    errors
  };
}
